import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDonut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="var(--dataviz-color-sequential-blue-scale05)"
      d="M7.159 9.609a10.78 10.78 0 0 0 10.992 15.12l-.512-4.758a5.994 5.994 0 0 1-6.111-8.407z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      d="M18.044 24.742a10.78 10.78 0 0 0 7.92-16.714l-3.98 2.658a5.993 5.993 0 0 1-4.404 9.293z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      d="M27.092 10.225A10.778 10.778 0 0 0 10.71 5.26l2.793 3.886a5.993 5.993 0 0 1 9.11 2.761l4.48-1.68Z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale06)"
      d="M11.15 4.958a10.8 10.8 0 0 0-4.167 5.077L11.43 11.8a6 6 0 0 1 2.317-2.823l-2.599-4.019Z"
    />
  </svg>
);
export default SvgDonut;
